module.exports = __webpack_public_path__ + "0115ef8d0ca2272dcbf8cfab121ca4b6.svg";